export default __webpack_public_path__ + "static/SUPPORTS FOR LANGUAGE LEARNING 4_v2-cafe9a89459b1a5b2a516e4c3a6e0fb3.png";